// Mock data for Cellular Recovery Network - Partner Program

export const siteConfig = {
  name: "Cellular Recovery Network",
  tagline: "Healing Starts Within",
  logo: "https://customer-assets.emergentagent.com/job_oxidative-reset/artifacts/8oi374gq_Screenshot%202026-02-09%20at%209.14.06%E2%80%AFAM.png",
  calendlyUrl: "https://calendly.com/mariethewaternerd1/free-question-answer-session",
  contact: {
    email: "contact@crnnetwork.com",
    phone: "505 8407 5433"
  }
};

export const heroContent = {
  headline: "Walk Beside Them Through The Fire",
  subheadline: "Holding The Water",
  tagline: "Be the person you wished you had.",
  description: "Guide others through recovery with hydrogen therapy. Use your experience, your training, and your passion to build a business that transforms lives—one person at a time."
};

export const formSection = {
  title: "Ready to Make a Difference?",
  subtitle: "Natural leaders wanted.",
  description: "Are you passionate and ready to help others? Enter your details to receive information on how we train you to help others in recovery through cellular detox and hydrogen therapy.",
  buttonText: "Get The Information"
};

export const missionSection = {
  title: "Your Journey Becomes Their Lifeline",
  points: [
    {
      title: "Your Experience Matters",
      description: "You've walked through the fire. You know what it takes. That understanding can't be taught—it's earned."
    },
    {
      title: "Science Meets Compassion",
      description: "Hydrogen therapy addresses the cellular damage from years of substance use. You bring the heart. We bring the science."
    },
    {
      title: "Build Something Meaningful",
      description: "Create a business rooted in purpose. Help others heal while building a sustainable income for yourself and your family."
    }
  ]
};

export const hydrogenTherapyInfo = {
  title: "Cellular Recovery Through Hydrogen Therapy",
  subtitle: "Detox at the deepest level",
  intro: "Years of substance use creates oxidative stress and cellular damage throughout the body. Hydrogen therapy works where it matters most—inside your cells.",
  points: [
    {
      title: "Neutralizes Oxidative Damage",
      description: "Molecular hydrogen targets harmful free radicals at the cellular level, helping reverse years of accumulated damage."
    },
    {
      title: "Supports Natural Detox",
      description: "By restoring cellular health, the body's natural detoxification systems can function optimally again."
    },
    {
      title: "Whole-Body Restoration",
      description: "When cells heal, everything improves—energy, clarity, mood, and physical wellness. Recovery becomes sustainable."
    }
  ],
  image: "https://images.unsplash.com/photo-1666886573452-9dc8ce8f5cc5?w=800&q=80"
};

export const testimonials = [
  {
    name: "Ryan Cooper",
    duration: "1 month on hydrogen water",
    quote: "After just one month, my inflammation and neck pain improved significantly. But what shocked me most? I got my sense of smell back. I never thought that was possible.",
    results: ["Reduced inflammation", "Less neck pain", "Restored sense of smell"]
  },
  {
    name: "Judith Medrano",
    duration: "Recovery journey",
    quote: "My back pain is better, I can breathe again, and my energy is through the roof. I went from being out of breath just walking to actually taking up running. This water changed my life.",
    results: ["Reduced back pain", "Improved breathing", "Increased energy", "Started running"]
  }
];

export const opportunityDetails = {
  title: "We Train You To Guide Others",
  subtitle: "Everything you need to help people heal",
  benefits: [
    {
      icon: "GraduationCap",
      title: "Complete Training",
      description: "Learn the science of hydrogen therapy and how to guide others through cellular recovery."
    },
    {
      icon: "Handshake",
      title: "Ongoing Mentorship",
      description: "You're never alone. Our team supports you every step of the way."
    },
    {
      icon: "Droplets",
      title: "Professional Equipment",
      description: "Access to proven hydrogen water systems that deliver real, measurable results."
    },
    {
      icon: "Users",
      title: "Community",
      description: "Join a network of like-minded individuals dedicated to helping others recover."
    },
    {
      icon: "FileText",
      title: "Resources & Materials",
      description: "Educational content, client materials, and marketing support to help you grow."
    },
    {
      icon: "Compass",
      title: "Proven Path",
      description: "7 years of experience. A tested approach. Real results."
    }
  ]
};

export const faqItems = [
  {
    question: "Do I need medical credentials?",
    answer: "No medical credentials are required. Hydrogen water is a wellness product. We provide comprehensive training on how to educate and guide clients effectively."
  },
  {
    question: "What kind of training do you provide?",
    answer: "We train you on the science of hydrogen therapy, how to work with people in recovery, and how to build a sustainable business. You'll have ongoing support throughout."
  },
  {
    question: "Is the science legitimate?",
    answer: "Absolutely. Over 1,000 peer-reviewed studies validate the therapeutic effects of molecular hydrogen. We'll equip you with the research and educational materials."
  },
  {
    question: "How quickly can I get started?",
    answer: "Most partners are up and running within 2-4 weeks after completing training. We provide a clear roadmap and support every step of the way."
  }
];

export const ctaSection = {
  title: "Be The Guide You Wished You Had",
  subtitle: "Walk beside others through the fire. Help them heal at the cellular level.",
  buttonText: "Book Your Free Q&A Session",
  note: "No pressure. Just an honest conversation about whether this path is right for you."
};

// Mock leads storage (will be replaced with actual backend)
export const mockLeads = [];
